<template>
  <div>
    <v-row>
      <v-col
        sm="6"
        md="4"
        v-for="product in $store.state.products"
        :key="product.name"
      >
        <VerticalProduct :product="product" :addToCart="addToCart" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VerticalProduct from "./VerticalProduct";
export default {
  components: {
    VerticalProduct
  },
  methods: {
    addToCart(index, quantity = 1) {
      this.$store.commit("addItemToCart", { itemId: index, quantity });
      this.$store.commit("updateSnackbar", {
        show: true,
        message: index.name + " in den Warenkorb gelegt."
      });
    }
  }
};
</script>
